export default __webpack_public_path__ + "static/how-we-built-a-navigation-header-7f10f1757b0556d41dfe8281b4454f6ff802eaaf601816ff4064a7dcda0b030f.png";